<script setup lang="ts">
import {Settings2} from "@lucide/vue";

defineProps<{
  on: boolean;
}>();

const expanded = defineModel<boolean>();
</script>

<template>
  <div class="flex flex-col items-end pt-1">
    <v-label>
      {{
        on
          ? 'Notifications activées'
          : 'Notifications désactivées'
      }}
    </v-label>
    <button
      v-if="on"
      class="text-sm underline flex items-center gap-1"
      @click="expanded = !expanded"
    >
      <Settings2 :size="10" />
      {{ expanded ? "Masquer la personnalisation" : "Personnaliser les notifications" }}
    </button>
  </div>
</template>
